module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticStyle: {
      "page-break-before": "always"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center",
      "width": "100%"
    }
  }, [_c('h1', {
    staticClass: "P_Heading_1__And__Page_Break",
    staticStyle: {
      "width": "100%",
      "max-width": "100%",
      "max-height": "100%",
      "display": "inline-block"
    }
  }, [_c('span', [_c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "alt": "",
      "src": "image6.jpg"
    }
  })])])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Norm-NoIndRagRt"
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("Present Day: Farah, Iraq")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal__And__Left_Indent"
  }, [_c('span', {
    staticStyle: {
      "font-size": "0.93em"
    }
  }, [_vm._v("CARRICK JAMES")]), _c('span', {
    staticStyle: {
      "font-size": "1.17em"
    }
  }), _vm._v("Francis grew up in Levee Oaks, California. While not exactly Death Valley, it was pretty hot in the summer—the temperature reached the hundreds fairly regularly between June and September, and a hot wind blew through the valley when the delta breezes were too fucking lazy to move.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("After two years in Iraq, he was starting to wish it had been Death Valley. If he’d grown up in Death Valley, he figured driving an ambulance in Kuwait wouldn’t feel like the seventh sphincter of the armpit demon living in hell’s tenth colon.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Two years and I still can’t believe this place makes my hometown look good!” Crick had to shake his head in disgust. His whole life, he’d hated Levee Oaks. He’d almost gotten expelled from school for painting “White Trash Capital of California” on the water tower. If Deacon hadn’t painted it over before the whole town had seen it, he would have been.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Just one more thing he owed Deacon Winters for. One more giant favor he’d returned with complete dumb-assery.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Yeah, well,” Private Lisa Arnold was saying, “you won’t be here much longer, Punky, so you need to quit your bitching!” Crick’s partner shook her head next to him, as cute and blonde and perky in full gear, flak jacket, and helmet in the front of the ambulance as she would have been wearing bottle-cap shorts and a halter-top at a family reunion. She’d always been a little burst of sweet ’n cool in the middle of the desert, and Carrick had grown to love her like a sister. An older sister, of course. He’d had enough of cleaning, diapering, and feeding his little half-sisters to last a lifetime.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Carrick blew out a breath and looked at the armored transport trucks in front of them—a whole lot of soldiers getting to go home. But first, they had to look down the long road of sand and sand and nothing but fucking sand from Farah to Baghdad, where their flight would take off.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“How long again?” They drove an ambulance with full a/c, mostly because half of what they treated was heat exhaustion. There had been wounds—and that had been bad enough, food for nightmares—but three-quarters of their job had been handing out fluids and ice packs, keeping the combat units from poaching their brains like eggs in the roasting pan that was the Middle East. The a/c was more of a suggestion than a rule, really—a pleasant suggestion, most times, but nothing like the good ozone-eating a/c of a department store in California.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Lisa looked at him sideways. “Five days. Here to Baghdad, BD to Turkey, Turkey to Germany, Germany to LA, LA to Sac. Badda bing, badda boom—you’re home, boy, and this gig, it ain’t nothing but a bad memory!”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Crick smiled and looked at her softly. “Gonna miss you, Popcorn,” he said, meaning it. It had been a long, miserable two-year tour—the biggest fucking mistake of his dumb-assed life. By the time Lisa Arnold had showed up, perky and kind and tough as nails, Crick had been thinking seriously about dancing naked in a minefield, just to make it end.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("But Lisa had showed up, and she’d been nosy and perky and in his face… and then she’d found out the one thing Crick hadn’t wanted anybody in the Army to know, and he’d been sure he was fucked.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("And she’d saved his life instead.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“You won’t miss me when you get home and he’s waiting for you.” She risked a glance off the road—purely against protocol—and in the face of that cute, scrunchy, freckled affection, he tried not to let his anxiety show.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“You think he’ll be okay?” He didn’t even want to ask her again. He didn’t want to think about what life would be like back home if Deacon hadn’t been able to pull himself through, hadn’t been able to keep himself grounded for the last four months. The man had lived his entire life as a paragon of virtue—until Crick left him and his world fell apart.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Lisa shook her head and frowned absently at something hazy that was ripping through the glare in front of them. “Oh, now baby—you read me the letters. Please, don’t—”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("The sentence never got finished. The transport in front of them exploded, became shrapnel, and ripped through their bus like a thousand serrated throwing stars, glowing red with the blast.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Crick tried for the rest of his life to forget Lisa disintegrating, shattering in front of him, while he was thrown around like a ragdoll in a drier—a ragdoll made of flesh and a drier made of knives.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Right before his head smacked earth, protected by that damned helmet, he had a moment of perfect clarity.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("Oh, goddammit, Deacon—I should have given you more time.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-34cb2de7","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/section0004.vue
// module id = 66
// module chunks = 0